/** @jsx h */
import { h } from 'preact';
import { connect } from 'react-redux';
import { tracker, UserActionType } from '../../tracking';
import onPaymentCancel from '../../actions/onPaymentCancel';
import actionType from '../../actions/onPaymentCancel/actionType';
import style from './style.css';

const ConfirmCancelButton = (props) => {
  const { isPosTransaction } = props;
  const onClickAction = () => {
    props.onPaymentCancel(actionType.confirmCancellation);
    const metadataObj = {
      ...props.metadata,
    };
    if (!isPosTransaction) {
      let cancellationReason = props.cancellationReason;
      metadataObj.cancellationType = cancellationReason;
      if (cancellationReason.includes('other:')) {
        cancellationReason = cancellationReason.split(':')[1];
        metadataObj.cancellationType = 'other';
      }
      metadataObj.cancellationReason = cancellationReason;
    }

    tracker.trackUserInteraction(
      UserActionType.CLICK,
      'confirm_cancel',
      props.pageKey,
      metadataObj,
    );
  };
  return (
    <div className={isPosTransaction ? style.cancelButtonContainer : ''}>
      <button
        className={`${
          !isPosTransaction ? style.cancelButton : ''
        } text80 text-center cursorPointer`}
        id='confirmCancelTransaction'
        onClick={onClickAction}>
        Cancel Transaction
      </button>
    </div>
  );
};

export default connect(
  null,
  { onPaymentCancel },
)(ConfirmCancelButton);



// WEBPACK FOOTER //
// ./components/cancelTransactionButton/confirmCancelButton.js